define('views/pages/AuthentificationPageView',['underscore', 'backbone', 'jquery', 'router', 'app', 'PageView',
    'WidgetCollectionView',
    'views/blocks/AuthentificationView',
    'views/blocks/OptinRgpdView',
    'TagCommander',
    'InputView',
    'template!authentification',
    'template!blocks/account/authentification',
    'template!reset-password'
], function (_, Backbone, $, router, app, PageView,
             WidgetCollectionView,
             AuthentificationView,
             OptinRgpdView,
             TagCommander,
             InputView,
             authentificationTemplate,
             blockAuthentificationTemplate,
             resetPasswordTemplate
)
{
    var view, customer;

    var AuthentificationPageView = PageView.extend({
        pageName: 'Authentification',
        className: 'page Authentification',
        displayAsModal: true,
        events: {
            'click .btn-close': 'success',

            'change .already-registered': 'toggleForm',

            'submit .reset-password-form': 'submitResetPasswordForm'
        },

        initialize: function (options)
        {

            view = this;
            view.options = _.defaults(options,{introduction:false,isComein:true});

            view.reset_password_link = view.$('.password-reset').data('link');

            // PageView constructor heritage
            PageView.prototype.initialize.apply(view, arguments);
            //
            //
            customer = app.getCustomer();
            if(customer.isLogged() && !view.reset_password_link){
                setTimeout(function(){
                    // prevent DDOS attack and deport
                    app.go('accountDashboard');
                    view.trigger('close',view);
                },10);
                return;
            }
            view.render();
            view.listenTo(customer, 'login', view.successLogin);
        },
        trackPageView:function(){
            TagCommander.LoadPage(this.pageName,{});
        },


        successLogin: function ()
        {

            var view = this,
                customer = app.getCustomer();
            view.trigger('close', view);

            //customer.remoteFetch();
            //requireRgpdOptin();
        },

        render: function ()
        {
            if(view.reset_password_link){
                view.$el.html(resetPasswordTemplate({link:view.reset_password_link,theme:'dark'}));
                var resetPasswordMessageView = new WidgetCollectionView('passwordreset');
                view.$('.widget-container').append(resetPasswordMessageView.$el);
                view.attachView(resetPasswordMessageView);
                view.attachViews(InputView.initializeInputsOfView(view));
                return;
            }

            var comeinIdObject = this.$('#is_comein'),flagcomin=0,comeinId=0;
            if (comeinIdObject)
            {

                comeinId =   comeinIdObject.data('comein');
                flagcomin =   comeinIdObject.data('flagcomin');

            }
           view.$el.html(authentificationTemplate(view.options));
           var blockAuthentification = view.appendView(AuthentificationView,'.authentification-block',
                _.defaults(view.options,{
                    register: false,
                    newsletter:true,
                    render:true,
                    comeinId:comeinId,
                    flagcomin:flagcomin
                })
           );
            view.listenTo(blockAuthentification, 'success', view.success);
            blockAuthentification.render();
            view.delegateEvents();
            if (comeinId || flagcomin)
            {

                view.$('.toggle-group').removeClass('active');
                 view.$('.toggle-group.signup' ).addClass('active');
                //
                view.$('input[name=id_customer_comin]' ).val(comeinId);

            }

        },
        submitResetPasswordForm:function(){
            var view = this,
                link = view.$('[name=password_link]').val(),
                password = view.$('[name=password]').val(),
                password_confirmation = view.$('[name=password_confirmation]').val();
            function alertDanger(message){
                view.$('.alert-danger').show().html(message);
            }
            if(!password.length>0){
                alertDanger(app.t('Veuillez saisir un mot de passe','Authentification'));
            }else if(password !== password_confirmation){
                alertDanger(app.t('Votre confirmation de mot de passe n’est pas identique','Authentification'));
            }else{
                var customer = app.getCustomer();
                customer.resetPassword({link:link,password:password}).done(function(){
                        view.success();
                        if(customer.isLogged()){
                            app.go('accountDashboard');
                        }else{
                            app.go('authentification');
                        }
                    }
                ).fail(function (data, status){
                    var responseJSON = data.responseJSON;
                    if(responseJSON && responseJSON.error){
                        alertDanger(responseJSON.error);
                    }
                });
            }
            return false;
        },
        success: function ()
        {
            this.trigger('close', this);
        }
    });

    return AuthentificationPageView;

});
